import { CustomTabPanel } from '../CustomPanel';
import DateRangeDiv from '../HeaderMenu/DateRangeDiv';
import type {
  productionLoadingStates,
  loaderDailyAveragesType,
} from 'types/production.types';
import LoaderAnalyticsWrapper from './component/LoaderAnalyticsWrapper';
import AssetView from './component/LoaderAssetView';

interface Props {
  value: number;
  enableDarkTheme: boolean;
  isSelected: string;
  setIsSelected: any;
  handleDateChange: any;
  startDate: any;
  setStartDate: any;
  endDate: any;
  setEndDate: any;
  yesterday: any;
  unitSystem: string;
  customerCode: string;
  loadingStates: productionLoadingStates;
  assetOverview: any;
  data: loaderDailyAveragesType;
  aggregation: string;
  setAggregation: any;
  shiftWiseAnalysis: boolean;
  setShiftWiseAnalysis: any;
  shiftNumber: number;
  setShiftNumber: any;
  isPrinting: boolean;
  setAnalyticsData: any;
  handleFetchCustomDateRangeData: ({
    aggregation,
  }: {
    aggregation: string;
  }) => void;
  handleFetchCustomOnAggregationChange: ({
    aggregation,
    startDate,
    endDate,
  }: {
    aggregation: string;
    startDate: Date;
    endDate: Date;
  }) => void;
}

const Loader = ({
  value,
  enableDarkTheme,
  isSelected,
  setIsSelected,
  handleDateChange,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  yesterday,
  unitSystem,
  customerCode,
  loadingStates,
  assetOverview,
  aggregation,
  setAggregation,
  shiftWiseAnalysis,
  setShiftWiseAnalysis,
  shiftNumber,
  setShiftNumber,
  isPrinting,
  setAnalyticsData,
  handleFetchCustomDateRangeData,
  handleFetchCustomOnAggregationChange,
}: Props) => {
  return (
    <>
      <CustomTabPanel value={value} index={2}>
        <div>
          <DateRangeDiv
            enableDarkTheme={enableDarkTheme}
            isSelected={isSelected}
            setIsSelected={setIsSelected}
            handleDateChange={handleDateChange}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            yesterday={yesterday}
            ignoreYtd={false}
            aggregation={aggregation}
            setAggregation={setAggregation}
            shiftWiseAnalysis={shiftWiseAnalysis}
            setShiftWiseAnalysis={setShiftWiseAnalysis}
            shiftNumber={shiftNumber}
            setShiftNumber={setShiftNumber}
            handleFetchCustomDateRangeData={handleFetchCustomDateRangeData}
            handleFetchCustomOnAggregationChange={
              handleFetchCustomOnAggregationChange
            }
          />

          <LoaderAnalyticsWrapper
            isLoading={loadingStates.isLoadingLoaders}
            assetOverview={assetOverview}
            aggregation={aggregation}
            isSelected={isSelected}
            setAnalyticsData={setAnalyticsData}
          />

          <AssetView
            enableDarkTheme={enableDarkTheme}
            unitSystem={unitSystem}
            customerCode={customerCode}
            isLoading={loadingStates.isLoadingLoaders}
            isSelected={isSelected}
            startDate={startDate}
            endDate={endDate}
            isPrinting={isPrinting}
          />
        </div>
      </CustomTabPanel>
    </>
  );
};

export default Loader;
